import axios from "axios";
import { API } from "./brand";

// Shared axios instance for the whole app. `withCredentials` is required so
// `session_token` and `access_token` cookies travel on every backend call,
// keeping us aligned with AuthContext's own axios client.
export const api = axios.create({
  baseURL: API,
  timeout: 25000,
  withCredentials: true,
});
